document.addEventListener("alpine:init", () => {
  // === адреса в Sepolia / mainnet ===
  const STAKING_ADDRESS = "0x121ce7e07f1059670f727628ac6e1da9e5ed08e3";
  const CRB_ADDRESS = "0x997343a20A822a3FA67A6C56D0854d5Bd622C49a";

  const TOKEN_ABI = [
    { type: "constructor", inputs: [], stateMutability: "nonpayable" },
    {
      type: "function",
      name: "MAX_SUPPLY",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "allowance",
      inputs: [
        { name: "owner", type: "address", internalType: "address" },
        { name: "spender", type: "address", internalType: "address" },
      ],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "approve",
      inputs: [
        { name: "spender", type: "address", internalType: "address" },
        { name: "value", type: "uint256", internalType: "uint256" },
      ],
      outputs: [{ name: "", type: "bool", internalType: "bool" }],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "balanceOf",
      inputs: [{ name: "account", type: "address", internalType: "address" }],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "burn",
      inputs: [{ name: "value", type: "uint256", internalType: "uint256" }],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "burnFrom",
      inputs: [
        { name: "account", type: "address", internalType: "address" },
        { name: "value", type: "uint256", internalType: "uint256" },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "decimals",
      inputs: [],
      outputs: [{ name: "", type: "uint8", internalType: "uint8" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "name",
      inputs: [],
      outputs: [{ name: "", type: "string", internalType: "string" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "symbol",
      inputs: [],
      outputs: [{ name: "", type: "string", internalType: "string" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "totalSupply",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "transfer",
      inputs: [
        { name: "to", type: "address", internalType: "address" },
        { name: "value", type: "uint256", internalType: "uint256" },
      ],
      outputs: [{ name: "", type: "bool", internalType: "bool" }],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "transferFrom",
      inputs: [
        { name: "from", type: "address", internalType: "address" },
        { name: "to", type: "address", internalType: "address" },
        { name: "value", type: "uint256", internalType: "uint256" },
      ],
      outputs: [{ name: "", type: "bool", internalType: "bool" }],
      stateMutability: "nonpayable",
    },
    {
      type: "event",
      name: "Approval",
      inputs: [
        {
          name: "owner",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "spender",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "value",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "Transfer",
      inputs: [
        {
          name: "from",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        { name: "to", type: "address", indexed: true, internalType: "address" },
        {
          name: "value",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
      ],
      anonymous: false,
    },
    {
      type: "error",
      name: "ERC20InsufficientAllowance",
      inputs: [
        { name: "spender", type: "address", internalType: "address" },
        { name: "allowance", type: "uint256", internalType: "uint256" },
        { name: "needed", type: "uint256", internalType: "uint256" },
      ],
    },
    {
      type: "error",
      name: "ERC20InsufficientBalance",
      inputs: [
        { name: "sender", type: "address", internalType: "address" },
        { name: "balance", type: "uint256", internalType: "uint256" },
        { name: "needed", type: "uint256", internalType: "uint256" },
      ],
    },
    {
      type: "error",
      name: "ERC20InvalidApprover",
      inputs: [{ name: "approver", type: "address", internalType: "address" }],
    },
    {
      type: "error",
      name: "ERC20InvalidReceiver",
      inputs: [{ name: "receiver", type: "address", internalType: "address" }],
    },
    {
      type: "error",
      name: "ERC20InvalidSender",
      inputs: [{ name: "sender", type: "address", internalType: "address" }],
    },
    {
      type: "error",
      name: "ERC20InvalidSpender",
      inputs: [{ name: "spender", type: "address", internalType: "address" }],
    },
  ];

  const STAKING_ABI = [
    {
      type: "constructor",
      inputs: [
        { name: "_token", type: "address", internalType: "contract IERC20" },
      ],
      stateMutability: "nonpayable",
    },
    { type: "fallback", stateMutability: "payable" },
    { type: "receive", stateMutability: "payable" },
    {
      type: "function",
      name: "calculateRewards",
      inputs: [
        { name: "_amount", type: "uint256", internalType: "uint256" },
        {
          name: "_duration",
          type: "uint8",
          internalType: "enum IStaking.Duration",
        },
      ],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "pure",
    },
    {
      type: "function",
      name: "getDurationAPRRewards",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "tuple[3]",
          internalType: "struct IStaking.DurationAPRRewards[3]",
          components: [
            {
              name: "duration",
              type: "uint8",
              internalType: "enum IStaking.Duration",
            },
            { name: "lockTimeDays", type: "uint256", internalType: "uint256" },
            { name: "apr", type: "uint256", internalType: "uint256" },
          ],
        },
      ],
      stateMutability: "pure",
    },
    {
      type: "function",
      name: "getUsersStakePositions",
      inputs: [{ name: "user", type: "address", internalType: "address" }],
      outputs: [
        {
          name: "positions",
          type: "tuple[]",
          internalType: "struct IStaking.StakePosition[]",
          components: [
            { name: "id", type: "uint256", internalType: "uint256" },
            { name: "owner", type: "address", internalType: "address" },
            { name: "amount", type: "uint256", internalType: "uint256" },
            { name: "startTime", type: "uint256", internalType: "uint256" },
            { name: "rewards", type: "uint256", internalType: "uint256" },
            {
              name: "duration",
              type: "uint8",
              internalType: "enum IStaking.Duration",
            },
            { name: "claimed", type: "bool", internalType: "bool" },
          ],
        },
      ],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "owner",
      inputs: [],
      outputs: [{ name: "", type: "address", internalType: "address" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "renounceOwnership",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "setStakingStartTime",
      inputs: [
        { name: "_stakingStartTime", type: "uint256", internalType: "uint256" },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "stake",
      inputs: [
        { name: "_amount", type: "uint256", internalType: "uint256" },
        {
          name: "_duration",
          type: "uint8",
          internalType: "enum IStaking.Duration",
        },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "stakePositions",
      inputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      outputs: [
        { name: "id", type: "uint256", internalType: "uint256" },
        { name: "owner", type: "address", internalType: "address" },
        { name: "amount", type: "uint256", internalType: "uint256" },
        { name: "startTime", type: "uint256", internalType: "uint256" },
        { name: "rewards", type: "uint256", internalType: "uint256" },
        {
          name: "duration",
          type: "uint8",
          internalType: "enum IStaking.Duration",
        },
        { name: "claimed", type: "bool", internalType: "bool" },
      ],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "stakingStartTime",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "token",
      inputs: [],
      outputs: [{ name: "", type: "address", internalType: "contract IERC20" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "totalAllocatedFunds",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "totalStakePositions",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "totalStaked",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "transferOwnership",
      inputs: [{ name: "newOwner", type: "address", internalType: "address" }],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "unstake",
      inputs: [
        { name: "_positionIds", type: "uint256[]", internalType: "uint256[]" },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "usersStakePositions",
      inputs: [
        { name: "", type: "address", internalType: "address" },
        { name: "", type: "uint256", internalType: "uint256" },
      ],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "event",
      name: "OwnershipTransferred",
      inputs: [
        {
          name: "previousOwner",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "newOwner",
          type: "address",
          indexed: true,
          internalType: "address",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "StakePositionCreated",
      inputs: [
        {
          name: "user",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "stakePositionId",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
        {
          name: "startTime",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
        {
          name: "duration",
          type: "uint8",
          indexed: false,
          internalType: "enum IStaking.Duration",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "StakingStartTimeUpdated",
      inputs: [
        {
          name: "oldStartTime",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
        {
          name: "newStartTime",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "Unstaked",
      inputs: [
        {
          name: "user",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "positionIds",
          type: "uint256[]",
          indexed: false,
          internalType: "uint256[]",
        },
      ],
      anonymous: false,
    },
    { type: "error", name: "CallerDoesNotOwnStakePosition", inputs: [] },
    { type: "error", name: "CannotStakeZero", inputs: [] },
    {
      type: "error",
      name: "CannotUnstakeBeforeEndTime",
      inputs: [
        { name: "currentTime", type: "uint256", internalType: "uint256" },
        { name: "endTime", type: "uint256", internalType: "uint256" },
      ],
    },
    { type: "error", name: "CannotUnstakeZeroPositions", inputs: [] },
    { type: "error", name: "FallbackNotAllowed", inputs: [] },
    {
      type: "error",
      name: "InsufficientContractBalanceForStaking",
      inputs: [
        { name: "contractBalance", type: "uint256", internalType: "uint256" },
        { name: "requiredAmount", type: "uint256", internalType: "uint256" },
      ],
    },
    { type: "error", name: "InvalidDuration", inputs: [] },
    {
      type: "error",
      name: "OwnableInvalidOwner",
      inputs: [{ name: "owner", type: "address", internalType: "address" }],
    },
    {
      type: "error",
      name: "OwnableUnauthorizedAccount",
      inputs: [{ name: "account", type: "address", internalType: "address" }],
    },
    { type: "error", name: "ReceiveNotAllowed", inputs: [] },
    {
      type: "error",
      name: "SafeERC20FailedOperation",
      inputs: [{ name: "token", type: "address", internalType: "address" }],
    },
    {
      type: "error",
      name: "StakePositionAlreadyClaimed",
      inputs: [
        { name: "positionId", type: "uint256", internalType: "uint256" },
      ],
    },
    { type: "error", name: "StakingNotStarted", inputs: [] },
    {
      type: "error",
      name: "StakingStartTimeAlreadySetToSameValue",
      inputs: [],
    },
    { type: "error", name: "StakingStartTimeMustBeInFuture", inputs: [] },
  ];

  Alpine.data("staking", () => ({
    connected: false,
    address: null,
    signer: null,

    totalStaked: 0,
    myStaked: 0,
    myRewards: 0,

    crb: null,
    staking: null,
    crbDecimals: 18,

    amountStr: "",
    crbBalance: 0,
    allowance: 0,
    pending: false,

    plans: [
      {
        id: 0,
        name: "Bronze",
        lockTimeDays: 30,
        aprPct: 8.0,
        color: "#C98644",
      },
      {
        id: 1,
        name: "Silver",
        lockTimeDays: 90,
        aprPct: 12.0,
        color: "#DCDCDC",
      },
      {
        id: 2,
        name: "Gold",
        lockTimeDays: 180,
        aprPct: 18.0,
        color: "#C6AF55",
      },
    ],
    selectedPlanId: 2,

    positions: [],
    selectedId: null,

    toastEl: null,
    toastTimeout: null,

    initToast() {
      this.$watch("pending", (val) => {
        if (val) {
          this.showToast("Processing transaction…", "pending", {
            persistent: true,
          });
        } else {
          this.removeToast();
        }
      });
    },

    lockDaysFor(dur) {
      return dur === 0 ? 30 : dur === 1 ? 90 : 180;
    },

    isUnlockable(pos) {
      const end =
        Number(pos.startTime) + this.lockDaysFor(pos.duration) * 86400;
      return !pos.claimed && Math.floor(Date.now() / 1000) >= end;
    },

    isSelected(id) {
      return this.selectedId === Number(id);
    },

    selectPos(pos) {
      const id = Number(pos.id);
      this.selectedId = this.selectedId === id ? null : id;
    },

    clearSelection() {
      this.selectedId = null;
    },

    canUnstake(pos) {
      return (
        pos &&
        this.isUnlockable(pos) &&
        this.selectedId === Number(pos.id) &&
        !this.pendingUnstake
      );
    },

    get selectedPos() {
      return this.positions.find((p) => p.id === this.selectedId) || null;
    },

    get selectedPlan() {
      return (
        this.plans.find((p) => p.id === this.selectedPlanId) || this.plans[0]
      );
    },

    isPlanDropdownOpen: false,

    togglePlanDropdown() {
      this.isPlanDropdownOpen = !this.isPlanDropdownOpen;
    },

    async init() {
      if (!window.ethers || !window.stakingWallet) {
        console.error("[staking] Missing bridge or window.ethers");
        return;
      }
      await this.waitForWallet();

      // создаём read-only провайдер
      this.roProvider = window.stakingWallet.getEthersProvider();
      this.crbRO = new window.ethers.Contract(
        CRB_ADDRESS,
        TOKEN_ABI,
        this.roProvider
      );
      this.stakingRO = new window.ethers.Contract(
        STAKING_ADDRESS,
        STAKING_ABI,
        this.roProvider
      );

      this.crbDecimals = await this.crbRO.decimals().catch(() => 18);

      await Promise.all([this.fetchKpis(), this.fetchWalletSide()]);
      setInterval(() => this.fetchKpis(), 30000);
    },

    async waitForWallet(timeoutMs = 15000) {
      const t0 = Date.now();
      while (Date.now() - t0 < timeoutMs) {
        const w = window.stakingWallet;
        if (w && w.isConnected()) {
          this.connected = true;
          this.address = w.getAddress();
          this.signer = await this.getSigner();
          if (this.signer) return;
        }
        await new Promise((r) => setTimeout(r, 300));
      }
      throw new Error("Wallet not connected");
    },

    async getSigner() {
      const rawProvider =
        window.stakingWallet.getEIP1193Provider?.() || window.ethereum;
      if (!rawProvider) throw new Error("Provider not available");
      if (!this.address) throw new Error("Address not available");

      const provider = new window.ethers.BrowserProvider(rawProvider);
      return await provider.getSigner(this.address);
    },

    async fetchKpis() {
      const ro = window.stakingWallet.getEthersProvider();
      const stakingRO = new window.ethers.Contract(
        STAKING_ADDRESS,
        STAKING_ABI,
        ro
      );

      // === totalStaked (как у тебя) ===
      try {
        const total = await stakingRO.totalStaked();
        this.totalStaked = parseFloat(
          window.ethers.formatUnits(total, this.crbDecimals)
        );
      } catch {
        // try {
        //   // 2) raw-call по правильному селектору 0xfc0c546a
        //   const data = "0xfc0c546a";
        //   const ret = await ro.call({ to: STAKING_ADDRESS, data });
        //   const bn = BigInt(ret);
        //   console.log(bn);
        //   this.totalStaked = parseFloat(
        //     window.ethers.formatUnits(bn, this.crbDecimals)
        //   );
        // } catch (e2) {
        //   console.warn(
        //     "[staking] raw totalStaked() failed, try storage slot #2:",
        //     e2
        //   );

        try {
          // 3) storage fallback — slot 2: totalStaked
          const raw = await ro.getStorage(STAKING_ADDRESS, 2n);
          this.totalStaked = parseFloat(
            window.ethers.formatUnits(BigInt(raw), this.crbDecimals)
          );
        } catch (e3) {
          console.error("[staking] storage read failed:", e3);
          this.totalStaked = 0;
        }
        // }
      }

      // === мои позиции + суммы ===
      try {
        const positions = await stakingRO.getUsersStakePositions(this.address);

        let myStakeSum = 0;
        let myRewardSum = 0;

        // нормализуем для UI таблицы
        this.positions = positions
          .map((p) => {
            const durationId = Number(p.duration);
            const plan = this.plans.find((pl) => pl.id === durationId);
            const amount = parseFloat(
              window.ethers.formatUnits(p.amount, this.crbDecimals)
            );
            const rewards = parseFloat(
              window.ethers.formatUnits(p.rewards, this.crbDecimals)
            );
            myStakeSum += amount;
            myRewardSum += rewards;
            return {
              id: Number(p.id),
              amount: amount.toFixed(2),
              startTime: Number(p.startTime),
              rewards,
              durationId,
              lockDays: plan?.lockTimeDays ?? 0,
              claimed: Boolean(p.claimed),
            };
          })
          .sort((a, b) => {
            // сначала по времени (новые первыми), затем по id (на всякий случай)
            if (b.startTime !== a.startTime) return b.startTime - a.startTime;
            return b.id - a.id;
          });

        this.myStaked = myStakeSum;
        this.myRewards = myRewardSum;
      } catch (err) {
        console.error("Error fetching positions", err);
        this.positions = [];
        this.myStaked = 0;
        this.myRewards = 0;
      }
    },

    async fetchWalletSide() {
      const ro = window.stakingWallet.getEthersProvider();
      const crbRO = new window.ethers.Contract(CRB_ADDRESS, TOKEN_ABI, ro);
      try {
        const [balBN, allowanceBN] = await Promise.all([
          crbRO.balanceOf(this.address),
          crbRO.allowance(this.address, STAKING_ADDRESS),
        ]);

        this.crbBalance = parseFloat(
          window.ethers.formatUnits(balBN, this.crbDecimals)
        );
        this.allowance = parseFloat(
          window.ethers.formatUnits(allowanceBN, this.crbDecimals)
        );
      } catch (e) {
        console.warn("[staking] fetchWalletSide failed", e);
        this.crbBalance = 0;
        this.allowance = 0;
      }
    },

    setMax() {
      this.amountStr = this.crbBalance.toString();
    },

    selectPlan(id) {
      this.selectedPlanId = id;
      if (this.isPlanDropdownOpen) {
        this.isPlanDropdownOpen = false;
      }
    },

    onAmountInput(e) {
      let val = e.target.value
        .replace(",", ".") // запятая → точка
        .replace(/[^0-9.]/g, "") // только цифры и точка
        .replace(/(\..*)\./g, "$1"); // одна точка

      // Ограничиваем дробную часть до 6 знаков
      const parts = val.split(".");
      if (parts[1]?.length > 6) {
        parts[1] = parts[1].slice(0, 6);
        val = parts.join(".");
      }

      e.target.value = val;
      this.amountStr = val;
    },

    // ===== форматтеры для таблицы =====
    fmtDate(tsSec) {
      if (!tsSec) return { text: "—", title: "" };

      const d = new Date(Number(tsSec) * 1000);

      // Текст в таблице — короткий формат
      const text = d.toLocaleString(undefined, {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      // Title — полная дата с годом
      const title = d.toLocaleString(undefined, {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return { text, title };
    },
    fmtTimeLeft(pos) {
      const now = Math.floor(Date.now() / 1000);
      const lockDays = pos.lockDays ?? 0;
      const unlockAt = Number(pos.startTime) + lockDays * 86400;
      const delta = unlockAt - now;
      if (pos.claimed) return "—";
      if (delta <= 0) return "Unlocked";
      const d = Math.floor(delta / 86400);
      const h = Math.floor((delta % 86400) / 3600);
      return (d ? `${d}d ` : "") + (h ? `${h}h` : d ? "" : "<1h");
    },
    canClaim(pos) {
      if (pos.claimed) return false;
      const now = Math.floor(Date.now() / 1000);
      const unlockAt = Number(pos.startTime) + (pos.lockDays ?? 0) * 86400;
      return now >= unlockAt;
    },

    _amountToBN() {
      const v = (this.amountStr || "").trim();
      if (!v) return null;
      try {
        const bn = window.ethers.parseUnits(v, this.crbDecimals);
        return bn > 0n ? bn : null;
      } catch {
        return null;
      }
    },

    async unstakeSelected(pos) {
      if (!this.canUnstake(pos)) return;

      this.pendingUnstake = true;
      try {
        const tx = await this.staking.unstake([Number(pos.id)]);
        await tx.wait();
        await Promise.all([this.fetchKpis(), this.fetchWalletSide()]);
        this.clearSelection();
        this.toast("Position unstaked!", "success");
      } catch (e) {
        console.error("[staking] unstake failed", e);
        this.toast(
          e?.reason || e?.shortMessage || "Transaction failed",
          "error"
        );
      } finally {
        this.pendingUnstake = false;
      }
    },

    async stakeTokens() {
      if (!this.connected) return;
      const amountBN = this._amountToBN();
      if (!amountBN) {
        this.showToast("Enter a valid amount", "error");
        return;
      }

      const amountHuman = parseFloat(
        window.ethers.formatUnits(amountBN, this.crbDecimals)
      );
      if (amountHuman > this.crbBalance + 1e-18) {
        this.showToast("Insufficient CRB balance", "error");
        return;
      }

      this.pending = true;
      try {
        const signer = await this.getSigner();
        const crb = new window.ethers.Contract(CRB_ADDRESS, TOKEN_ABI, signer);
        const staking = new window.ethers.Contract(
          STAKING_ADDRESS,
          STAKING_ABI,
          signer
        );

        if (this.allowance + 1e-12 < amountHuman) {
          const tx1 = await crb.approve(STAKING_ADDRESS, amountBN);
          await tx1.wait();
        }

        const tx2 = await staking.stake(amountBN, this.selectedPlanId);
        await tx2.wait();

        this.amountStr = "";
        await Promise.all([this.fetchKpis(), this.fetchWalletSide()]);
        this.showToast("Stake done", "success");
      } catch (e) {
        this.showToast(
          e?.reason || e?.shortMessage || "Transaction failed",
          "error"
        );
      } finally {
        this.pending = false;
      }
    },

    // одно-позиционное «claim/unstake» (разлоченные позиции)
    async claimPosition(posId) {
      if (!this.connected) return;
      this.pending = true;
      try {
        // unstake принимает массив id
        const tx = await this.staking.unstake([posId]);
        await tx.wait();
        await Promise.all([this.fetchKpis(), this.fetchWalletSide()]);
        this.toast("Success", "Position claimed", "success");
      } catch (e) {
        console.error("unstake failed", e);
        this.toast(
          "Error",
          e?.reason || e?.shortMessage || "Transaction failed",
          "error"
        );
      } finally {
        this.pending = false;
      }
    },

    fmtMaxBal(v) {
      return (v ?? 0)
        .toLocaleString(undefined, { maximumFractionDigits: 6 })
        .replace(/\u202F|\u00A0|,/g, " ");
    },

    fmt(v) {
      return (v ?? 0)
        .toLocaleString(undefined, { maximumFractionDigits: 4 })
        .replace(/\u202F|\u00A0|,/g, " ");
    },
    fmtRewards(v) {
      return (v ?? 0)
        .toLocaleString(undefined, { maximumFractionDigits: 2 })
        .replace(/\u202F|\u00A0|,/g, " ");
    },
    showToast(msg, type = "success", opts = {}) {
      if (this.toastEl) this.removeToast();

      this.toastEl = document.createElement("div");
      this.toastEl.textContent =
        (type === "error"
          ? "❌"
          : type === "success"
          ? "✅"
          : "pending"
          ? "⌛️"
          : "ℹ️") +
        " " +
        msg;

      Object.assign(this.toastEl.style, {
        position: "fixed",
        top: "120px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: "9999",
        padding: "8px 10px",
        background: "white",
        boxShadow:
          "rgba(0, 0, 0, 0.1) 0px 3px 10px, rgba(0, 0, 0, 0.05) 0px 3px 3px",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: "500",
        color: "rgb(54, 54, 54)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        transition: "opacity 0.4s ease, transform 0.4s ease",
        opacity: "0",
        transform: "translateX(-50%) translateY(-20px)",
        backgroundColor:
          type === "success"
            ? "#16a34a"
            : type === "error"
            ? "#dc2626"
            : "white",
      });

      document.body.appendChild(this.toastEl);

      requestAnimationFrame(() => {
        this.toastEl.style.opacity = "1";
        this.toastEl.style.transform = "translateX(-50%) translateY(0)";
      });

      if (!opts.persistent) {
        this.toastTimeout = setTimeout(
          () => this.removeToast(),
          opts.duration || 3000
        );
      }
    },

    removeToast() {
      if (this.toastEl) {
        this.toastEl.remove();
        this.toastEl = null;
      }
      if (this.toastTimeout) {
        clearTimeout(this.toastTimeout);
        this.toastTimeout = null;
      }
    },
  }));
});
